import { render, staticRenderFns } from "./pendding-list.vue?vue&type=template&id=fe38878a&"
import script from "./pendding-list.vue?vue&type=script&lang=js&"
export * from "./pendding-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports